import { Modal, ModalBody, ModalContent } from "@heroui/react";
import { CircleXIcon } from "lucide-react";
import { formatTimestamp } from "../../utils";
import type { TransferTxFailed } from "./transfersConfig";

export function TransferFailedModal({
  isOpen,
  onClose,
  failedTxData,
}: {
  isOpen: boolean;
  onClose: () => void;
  failedTxData: TransferTxFailed | null;
}) {
  if (!failedTxData) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="flex items-center gap-4 p-8">
          <CircleXIcon className="size-24 stroke-1 text-red-500/90 fill-red-500/10 " />

          <p className="font-semibold text-large">Transfer failed!</p>

          <div className="flex flex-col gap-2 w-full">
            <div className="flex justify-between w-full">
              <div className="text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(failedTxData.timestamp)}</div>
            </div>
          </div>

          <details className="w-full bg-[#3F6784] p-4 rounded-2xl space-y-3 text-sm">
            <summary className="font-semibold text-[#ADC0D0] cursor-pointer">Error message</summary>
            <div className="font-semibold text-[#FF4D4D] mt-2 overflow-auto max-h-48">{failedTxData.errorMessage}</div>
          </details>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
